import Loadable from '@loadable/component';

const GuardList = Loadable(async () => import('./components/guard-list'));

const guardrailRoutes = {
  '/guardrails': {
    components: { main: GuardList },
    '/:guardId': {
      components: { main: GuardList }
    }
  }
};

export default guardrailRoutes;
